<script>
  import './style.scss';
  import template from './template.html';
  import { CommentIcon, MenuIcon, FileIcon, ReceiptIcon, MessageTextIcon  } from '../icons.js';
  import ClickOutside from 'vue-click-outside';

  export default {
    template,

    props: {
      items: Object,  //[{icon, type, selected}]

      multiSelect: {
        type: Boolean,
        default: false
      },

      selected: {
        type: Object,
        default: () => {
          return {
            type: 'All',
            name: 'All'
          }
        }
      }
    },

    methods: {

      getIcon (iconName) {
        return `${iconName}Icon`
      },

      selectAll () {
        this.items.forEach(item => item.selected = true);
      },

      itemSelected (selectedItem) {
        this.$emit('item-selected', selectedItem);

        this.hideDropdown();
      },

      hideDropdown () {
        if (this.isVisible) {
          this.isVisible = false;
          return;
        }
      },

      toggleDropdown (state) {
        this.isVisible = !this.isVisible;
      },

      toggleItem (item) {
        item.selected = !item.selected;

        let anySelected = false;
        let all = this.items.find(item => item.type == 'All');

        //check if any items are selected
        for (let i = 0; i < this.items.length; i++) {
          let item = this.items[i];

          if (item !== 'All' && item.selected) {
            anySelected = true;
            break;
          }
        }

        if (all) {
          all.selected = !anySelected;
        }

        this.$emit('item-toggled', item);
      }
    },

    watch: {

      //@TODO
      selected (selectedItem) {
        let {id, name, type} = selectedItem;

        this.selectedItem = {id, name, type};
      }
    },

    computed: {

      materialIcon () {
        return CommentIcon()
      },

      selectedCount () {
        return this.items.filter(item => item.selected && item.type !== 'All').length;
      },

      allSelected () {
        let all = this.items.find(item => item.type == 'All');

        return all && all.selected === true;
      },

      selectedItems () {
        let selected = [];

        for (let i = 0; i < this.items.length; i++) {
          let item = this.items[i];

          if (item.selected) selected.push(item);
        }

        return selected;
      }
    },

    data () {

      let selected = Object.assign({}, this.selected);

      return {
        isVisible: false,

        selectedItem: selected
      }
    },

    components: {
      CommentIcon,
      MenuIcon,
      FileIcon,
      ReceiptIcon,
      MessageTextIcon
    },

    directives: {
      ClickOutside
    },

    created () {
      //this.selectedItem = this.items[0];
    }
  }
</script>
